import { render, staticRenderFns } from "./MaxCommentInteractionsCard.vue?vue&type=template&id=39e7e1b8&scoped=true"
import script from "./MaxCommentInteractionsCard.vue?vue&type=script&lang=ts"
export * from "./MaxCommentInteractionsCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxCommentInteractionsCard.vue?vue&type=style&index=0&id=39e7e1b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e7e1b8",
  null
  
)

export default component.exports